import { AgeType } from '@eti/schema-types';
import { getTravelerName } from '../../common/utils/travelerNames';
import { getAgeTypeLabel } from '../../common/utils/ageTypes';
const getTravelerInfo = (travelers, travelerNames, defaultTravelerLabel) => (travelerId, index) => {
  const {
    ageType,
    name
  } = travelers.find(({
    id
  }) => id === travelerId);
  return {
    ageType,
    name: name || getTravelerName(travelerId, travelerNames, defaultTravelerLabel, index + 1)
  };
};
const getFilteredProducts = (options, adultLabel, childLabel) => {
  var _options$filter;
  const filteredOptions = options === null || options === void 0 || (_options$filter = options.filter(({
    ageType
  }) => ageType !== AgeType.Inf)) === null || _options$filter === void 0 ? void 0 : _options$filter.map(({
    ageType,
    id,
    name,
    priceRaw
  }) => ({
    ageType,
    id,
    name: `${name}, ${getAgeTypeLabel(ageType, adultLabel, childLabel, '')}`,
    priceRaw
  }));
  return filteredOptions;
};
export const getOptions = ({
  id,
  order = {},
  travelerNames,
  defaultTravelerLabel,
  adultLabel,
  childLabel
}) => {
  const {
    availableExtraProducts,
    sellSpecification,
    travelers
  } = order;
  const travelerInfoFor = getTravelerInfo(travelers, travelerNames, defaultTravelerLabel);
  if (travelers) {
    if (availableExtraProducts) {
      const product = availableExtraProducts.find(availableProduct => availableProduct.id === String(id));
      if (!product) {
        return [];
      }
      const products = product.sellSpecification.sellPriceTravelers.map(({
        travelerId,
        price
      }, index) => ({
        id: travelerId,
        priceRaw: price.price.value,
        ...travelerInfoFor(travelerId, index)
      }));
      const filteredProducts = getFilteredProducts(products, adultLabel, childLabel);
      return filteredProducts;
    }
    if (sellSpecification) {
      const products = sellSpecification.sellPriceTravelers.map(({
        price,
        travelerId
      }, index) => ({
        id: travelerId,
        priceRaw: price.price.value,
        ...travelerInfoFor(travelerId, index)
      }));
      const filteredProducts = getFilteredProducts(products, adultLabel, childLabel);
      return filteredProducts;
    }
  }
  return [];
};
//# sourceMappingURL=flexibleTicketTransformer.js.map